import { useState } from 'react';

import type { Question } from '@api/instant_survey/types';
import {
  ActionOverlayPopover,
  DragDropV2Icon,
  EyeClosedIcon,
  EyeIcon,
  Layout,
  TrashIcon,
} from '@utilities';

import styles from './_index.module.scss';

interface SubQuestionProps {
  children: React.ReactNode;
  index: number;
  isDraggable?: boolean;
  onDelete?: () => void;
  onExcludeFromCarryForward?: () => void;
  subQuestion: Question;
}

const SubQuestion = ({
  children,
  index,
  isDraggable,
  onDelete = () => {},
  onExcludeFromCarryForward = () => {},
  subQuestion,
}: SubQuestionProps) => {
  const [isDropdownActive, setIsDropdownActive] = useState(false);

  const hasPropertyIcons = subQuestion.excludeFromCarryForward;

  return (
    <Layout.Flex className={styles['sub-question']} gap="small">
      <div className={styles['sub-question-icons']}>
        <DragDropV2Icon style={{ visibility: isDraggable ? 'visible' : 'hidden' }} />
        <strong>{index + 1}</strong>
      </div>

      <Layout.Fill>{children}</Layout.Fill>

      {hasPropertyIcons && (
        <Layout.Flex className={styles['sub-question-properties']} gap="small">
          {subQuestion.excludeFromCarryForward && <EyeClosedIcon />}
          <div className={styles['sub-question-pipe']} />
        </Layout.Flex>
      )}

      <div className={styles['sub-question-controls']}>
        <ActionOverlayPopover
          hasArrow={false}
          isActive={isDropdownActive}
          onClick={() => setIsDropdownActive(!isDropdownActive)}
          onHide={() => setIsDropdownActive(false)}
        >
          <ul>
            {!subQuestion.isCarryForwardGenerated && (
              <li>
                <button
                  aria-label="Delete row"
                  onClick={() => {
                    onDelete();
                    setIsDropdownActive(false);
                  }}
                >
                  <TrashIcon />
                  <span>Delete</span>
                </button>
              </li>
            )}
            {subQuestion.isCarryForwardGenerated && (
              <li>
                <button
                  aria-label={
                    subQuestion.excludeFromCarryForward ? 'Include Option' : 'Exclude Option'
                  }
                  onClick={() => {
                    onExcludeFromCarryForward?.();
                    setIsDropdownActive(false);
                  }}
                >
                  {subQuestion.excludeFromCarryForward ? <EyeIcon /> : <EyeClosedIcon />}
                  <span>
                    {subQuestion.excludeFromCarryForward ? 'Include Option' : 'Exclude Option'}
                  </span>
                </button>
              </li>
            )}
          </ul>
        </ActionOverlayPopover>
      </div>
    </Layout.Flex>
  );
};

export default SubQuestion;
